module.exports = __webpack_public_path__ + "img/pic8.4dbb64ce.png";